<template>
    <div class="col-12 p-0">
        <div class="row no-gutters justify-content-center align-items-center py-2 results-card-header">
            <div class="col-12 justify-content-center align-items-center text-center">
                <h1 class="results-title-text mt-2">RESULTS</h1>
            </div>
        </div>
        <div id="race-numbers" class="row no-gutters d-flex justify-content-center align-items-center">
            <div class="col-sm-6 col-lg-6 px-2 text-center">
                <button class="race-number-button" v-for="index in 12" :key="index" v-bind:class="{'race-number-button-selected': (selectedRaceNumber === index)}" v-on:click="onRaceNumberClicked(index)">{{index}}</button>
            </div>
        </div>
        <div class="results-body">
            <div class="row no-gutters justify-content-space-evenly align-items-center mb-md-2 mt-lg-1">
                <div class="col-12 col-lg-4 order-lg-2 pt-2 mb-4">
                    <div class="row no-gutters">
                        <div class="col-12 text-center">
                            <div class="row no-gutters justify-content-center font-weight-bold mb-1">
                                <span class="font-italic flex-nowrap">Greyville - Sunday 14/10/2018</span>
                            </div>
                            <div class="row no-gutters justify-content-center">
                                <button class="race-card-info-header px-4 py-2 text">Race 3 - 13:45 - 1400m</button>
                            </div>
                            <div class="row no-gutters justify-content-center font-weight-bold">
                                <span class="font-italic flex-nowrap">3 year Old Racing Association Pit</span>
                            </div>
                            <div class="row no-gutters justify-content-center font-weight-bold">
                                <span class="font-italic flex-nowrap">Racing Association Plate</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row no-gutters justify-content-space-evenly align-items-center mt-2">
                <div class="col-11">
                    <div class="row no-gutters justify-content-space-evenly team-details-table">
                        <div style="position: relative;" class="col-12 px-1">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">POS</th>
                                        <th scope="col">#</th>
                                        <th scope="col">HORSE</th>
                                        <th scope="col">JOCKEY</th>
                                        <th scope="col">TRAINER</th>
                                        <th scope="col">SH</th>
                                        <th scope="col">WGT</th>
                                        <th scope="col">DRAW</th>
                                        <th scope="col">OP</th>
                                        <th scope="col">SP</th>
                                        <th scope="col">LEN</th>
                                        <th scope="col">TIME</th>
                                        <th scope="col">MR</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(result, index) in results" :key="index">
                                        <td v-if="(result.position < 6)" class="text-center">
                                            <img :src="getImage('wf-finishing-position-' + result.position)" class="finishing-position-icon" v-on:click="toggleFormGridVisibility()">
                                        </td>
                                        <td v-if="(result.position >= 6)" class="text-center" v-on:click="toggleFormGridVisibility()">{{result.position}}</td>
                                        <td>{{result.horseNumber}}</td>
                                        <td class="clickable-text" v-on:click="onHorseNameClicked('horseId')">{{result.horseName}}</td>
                                        <td class="clickable-text" v-on:click="onJockeyNameClicked('jockeyId')">{{result.jockeyName}}</td>
                                        <td class="clickable-text" v-on:click="onTrainerNameClicked('trainerId')">{{result.trainerName}}</td>
                                        <td>{{result.equipment}}</td>
                                        <td>{{result.weight}}</td>
                                        <td>{{result.draw}}</td>
                                        <td><sup>{{result.openingPrice.numerator}}</sup>&frasl;<sub>{{result.openingPrice.denominator}}</sub></td>
                                        <td><sup>{{result.startingPrice.numerator}}</sup>&frasl;<sub>{{result.startingPrice.denominator}}</sub></td>
                                        <td>{{result.length}}</td>
                                        <td>{{result.time}}</td>
                                        <td>{{result.meritRating}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <form-grid-modal v-if="isFormGridOpen" :toggleFormGridVisibilityCallback="toggleFormGridVisibility"></form-grid-modal>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';

    import FormGridModal from '../components/FormGridModal';

    import {ResultsMockData}from '../assets/mockData/results';

    export default {
        name: 'Results',
        components: {
            FormGridModal
        },
        data: function () {
            return {
                results: ResultsMockData,
                isFormGridOpen: false
            };
        },
        computed: mapState(['selectedRaceNumber']),
        methods: {
            getImage(imagePath, fileType = 'svg') {
                return require('../assets/images/' + imagePath + '.' + fileType);
            },
            onRaceNumberClicked(selectedRaceNumber) {
                this.setSelectedRaceNumber(selectedRaceNumber);
            },
            toggleFormGridVisibility() {
                this.isFormGridOpen = !this.isFormGridOpen;
            },
            onHorseNameClicked(horseId) {
                this.setSelectedHorse({});
                this.$router.push('/landing/statistics');
            },
            onTrainerNameClicked(trainerId) {
                this.setSelectedTrainer({});
                this.$router.push('/landing/statistics');
            },
            onJockeyNameClicked(jockeyId) {
                this.setSelectedJockey({});
                this.$router.push('/landing/statistics');
            },
            ...mapMutations(['setSelectedRaceNumber', 'setSelectedHorse', 'setSelectedTrainer', 'setSelectedJockey'])
        },
        mounted: function () {
        }
    }
</script>

<style scoped>
    .results-card-header {
        background-color: #000000;
    }

    .results-title-text {
        font-size: 1.8rem;
    }

    .results-body {
        background-color: #FFFFFF;
        border-top: solid 1px #000000;
    }

    #race-numbers {
        background-color: #000000;
        padding: 1rem;
    }

    .race-number-button {
        margin-right: 0.05rem;
        padding: 0.4rem;
        text-align: center;
        font-size: 0.7rem;
        font-weight: bold;
        color: #FFFFFF;
        background-color: transparent;
        border: solid 1px #FFFFFF;
        width: 8%;
    }

    .race-number-button-selected {
        background-color: #FFFFFF;
        color: #000000;
        cursor: pointer;
    }

    .race-number-button:hover {
        background-color: #FFFFFF;
        color: #000000;
        cursor: pointer;
    }

    .race-card-info-header {
        background-color: #000000;
        border-radius: 0.4rem;
        border: none;
        font-size: 1rem;
        margin-bottom: 0.5rem;
    }

    .race-card-info-header:hover {
        background-color: #000000 !important;
        cursor: auto;
    }

    .finishing-position-icon {
        width: 1.2rem;
        box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.35);
        border-radius: 50%;
    }

    .finishing-position-icon:hover {
        box-shadow: 2px 3px 8px 0 rgba(0, 0, 0, 0.8);
        cursor: pointer;
        position: relative;
    }

    td {
        font-size: 0.55rem;
    }

    .table-responsive {
        border: 1px solid #7c7c7c !important;
        margin-bottom: 0.5rem !important;
        box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.4);
    }

    @media (min-width: 576px) {
        .race-number-button {
            font-size: 0.8rem;
        }

        td {
            font-size: 0.9rem;
        }
    }

    span {
        font-size: 1.2rem;
    }

    @media only screen and (min-device-width: 0px) and (max-device-width: 1200px) and (orientation: landscape) {
        td {
            font-size: 1rem;
        }

        .race-card-info-header {
            font-size: 1.4rem;
        }
    }

    @media (min-width: 1200px) {
        .race-card-info-header {
            font-size: 1.3rem;
        }

        h1 {
            font-size: 4rem;
        }

        .race-number-button {
            font-size: 1.2rem;
            margin-right: 0.2rem;
            width: 7%;
        }

        td {
            font-size: 0.8rem;
        }

        .finishing-position-icon {
            margin: 2px;
            width: 1.7rem;
        }
    }

    @media (min-width: 1260px) {
        td {
            font-size: 1.2rem;
        }

        h1 {
            margin-top: 0.5rem;
            margin-bottom: 0 !important;
        }
    }
</style>
